var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tab-layout", {
    attrs: { buttons: _vm.buttons, permissions: _vm.permissions },
    on: { openCustomfields: _vm.openCustomfields },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$l10n.__("Champs personnalisés")) +
                "\n    "
            )
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _vm.loading
              ? _c(
                  "div",
                  { staticClass: "prelative mt-3" },
                  [_c("preloader", { attrs: { display: _vm.loading } })],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.loading
              ? _c("div", { staticClass: "flex-column overflow-initial" }, [
                  _vm.customFields.length > 0
                    ? _c(
                        "div",
                        [
                          _c("customfields", {
                            attrs: {
                              cfs: _vm.customFields,
                              cfv: _vm.customFieldValues,
                              emitEditSuccess: _vm.emitEditSuccess,
                              mode: "readtable"
                            }
                          })
                        ],
                        1
                      )
                    : _c("div", [
                        !_vm.loading
                          ? _c("div", { staticClass: "placeholder" }, [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$l10n.__(
                                      "Aucun champ personnalisé défini"
                                    )
                                  )
                                )
                              ])
                            ])
                          : _vm._e()
                      ])
                ])
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }